<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.64567 6.52083C9.64567 8.53333 8.01234 10.1667 5.99984 10.1667C3.98734 10.1667 2.354 8.53333 2.354 6.52083C2.354 4.50833 3.98734 2.875 5.99984 2.875C8.01234 2.875 9.64567 4.50833 9.64567 6.52083Z"
      :stroke="color"
      stroke-width="0.666667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 4.3335V6.41683"
      :stroke="color"
      stroke-width="0.666667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.75 1.8335H7.25"
      :stroke="color"
      stroke-width="0.666667"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconDuration',
  props: {
    size: {
      type: [Number, String],
      default: 12
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>
